module.exports = __webpack_public_path__ + "media/images/3-6680cd91.png";